import cookies from 'component-cookie';

export default (cookieOptions = { path: '/' }) => {
  cookies('tokens', null, cookieOptions);
  cookies('userType', null, cookieOptions);
  cookies('currentUserId', null, cookieOptions);
  cookies('currentUserRole', null, cookieOptions);
  cookies('isLoggedIn', null, cookieOptions);
};
